import { useEffect, useRef, useState } from "react";
import { xmarkIcon } from "../../source";
import "./popup.scss";
import { useNavigate } from "react-router-dom";
const PopUp = () => {
  const [showPopup, setShowPopup] = useState(false);
  const timeoutRef = useRef(null);
  useEffect(() => {
    const isSubscribed = localStorage.getItem("isSubscribed") === "true";

    if (!isSubscribed) {
      timeoutRef.current = setTimeout(() => {
        setShowPopup(true);
      }, 5000);
    }

    return () => clearTimeout(timeoutRef.current);
  }, []);

  const closePopUp = () => setShowPopup(false);

  const subscribeClick = () => {
    localStorage.setItem("isSubscribed", "true");
    setShowPopup(false);
    window.open(
      "https://youtube.com/@pathwaysandperspectives?si=z_69zV1bPVZsulYY",
      "_blank"
    );
  };

  return (
    <section id="popup_wrapper" className={showPopup ? "active" : ""}>
      <div className="popup">
        <img
          src={xmarkIcon}
          alt="Close Icon"
          className="close_icon"
          onClick={closePopUp}
        />
        <p>
          Stay updated <br /> subscribe to our YouTube channel!
        </p>
        <div className="btn" onClick={subscribeClick}>
          SUBSCRIBE NOW
        </div>
      </div>
    </section>
  );
};

export default PopUp;
